import { useTranslation } from "react-i18next";

/**
 * Suspense fallback for lazily-loaded routes.
 *
 * Mirrors AuthGate's `FullscreenSpinner` so a route chunk loading in looks
 * identical to the auth/session pending state. Intentionally imports nothing
 * heavy — it must be part of the eager app shell so it can paint instantly
 * while the route's own JS chunk is fetched.
 */
export function RouteFallback() {
  const { t } = useTranslation();
  return (
    <div className="grid h-full place-items-center bg-surface-0">
      <div
        className="h-6 w-6 animate-spin rounded-full border-2 border-line border-t-brand"
        role="status"
        aria-label={t("common.loading")}
      />
    </div>
  );
}
